// @flow
import React, { type Element } from 'react';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { urlCatalog } from 'angieslist-app-platform';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import _ from 'lodash';
import { Alert, Button, Label, Row } from 'angieslist-react-components';
import reviewsActions from '../../../common/reviewsActions';
import ReviewRetortDisplay from './ReviewRetortDisplay';
import ReviewRetortForm from './ReviewRetortForm';
import './reviewRetort.scss';
import type { BrowserReducerState } from '../../../types';
import type { ReviewsReducerState } from '../../../common/reviewsReducer';

type Props = {
  browser: BrowserReducerState,
  text: ?string,
  status?: string,
  reviewId: string,
  serviceProviderId: string,
  // redux
  reviews: ReviewsReducerState,
  // reviewsActions
  createOrUpdateRetort: typeof reviewsActions.createOrUpdateRetort,
}

type State = { editing: boolean };

export class ReviewRetortComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { editing: false };
    this.saveRetort = this.saveRetort.bind(this);
    this.startEditing = this.startEditing.bind(this);
    this.cancelEditing = this.cancelEditing.bind(this);
  }

  state: State;
  props: Props;

  startEditing: (() => void)= () => {
    this.setState({ editing: true });
  }

  cancelEditing: (() => void) = () => {
    this.setState({ editing: false });
  }

  saveRetort: ((values: {confirmation: boolean, text: string}) => void) =
  (values: { confirmation: boolean, text: string }) => {
    const { reviewId, serviceProviderId } = this.props;
    this.props.createOrUpdateRetort(serviceProviderId, reviewId, values.text);
    this.setState({ editing: false });
  }
  render(): Element<"div"> {
    const {
      browser, text, status, serviceProviderId, reviewId, reviews: { retort },
    } = this.props;
    const loading = !!retort.isLoading && _.get(retort, 'request.reviewId') === reviewId;
    const error = !!retort.error && !retort.isLoading && _.get(retort, 'request.reviewId') === reviewId;
    const isMobile = _.get(browser, 'lessThan.sm', false);

    return (
      <div>
        <If condition={error}>
          <Alert bsStyle="danger">
            There was an error saving your response. Let us help you by contacting <a id="app-download--error-phone-link" href={urlCatalog.global.businessCenterPhone()} >{urlCatalog.global.businessCenterPhoneText()}</a>.
          </Alert>
        </If>
        <Choose>
          <When condition={status === 'enqueued' || status === 'auto-rejected'}>
            <Label bsStyle="danger">STATUS PENDING</Label>
          </When>
          <When condition={status && status !== 'active'}>
            <Label bsStyle="danger">STATUS {(status && status.toUpperCase())}</Label>
          </When>
        </Choose>
        <Choose>
          <When condition={this.state.editing}>
            <ReviewRetortForm
              onSubmit={this.saveRetort}
              initialValues={{ text, confirmation: false }}
              form={`editRetort_${reviewId}`}
              onCancel={this.cancelEditing}
              serviceProviderId={serviceProviderId}
              reviewId={reviewId}
            />
          </When>
          <Otherwise>
            <Loader
              loading={loading}
              element={
                <Row className="text-center">
                  <i className="icon icon-load icon-spin icon-3x text-primary" />
                </Row>}
            >
              <div>
                <Choose>
                  <When condition={!!text}>
                    <ReviewRetortDisplay
                      text={text}
                      reviewId={reviewId}
                      handleEdit={this.startEditing}
                    />
                  </When>
                  <Otherwise>
                    <Alert bsClass="review-card_retort">
                      <Choose>
                        <When condition={isMobile}>
                          <Row style={{ fontSize: '0.9em', paddingBottom: '1em' }}>
                            <i className="icon icon-pencil icon-2x respond-pencil" />
                            <strong>Respond to this review!</strong>
                          </Row>
                          <Row>
                            <Button
                              id={`review-card--retort--respond-button-${reviewId}`}
                              className="review-card_retort-button"
                              bsSize="small"
                              style={{ marginLeft: '3em' }}
                              onClick={this.startEditing}
                              bsStyle="default-office"
                            >
                              Respond
                            </Button>
                          </Row>
                        </When>
                        <Otherwise>
                          <i className="icon icon-pencil icon-2x respond-pencil" />
                          <strong>Respond to this review!</strong>
                          <Button
                            id={`review-card--retort--respond-button-${reviewId}`}
                            className="review-card_retort-button"
                            bsSize="small"
                            style={{ marginLeft: '1em' }}
                            onClick={this.startEditing}
                            bsStyle="default-office"
                          >
                            Respond
                          </Button>
                        </Otherwise>
                      </Choose>
                    </Alert>
                  </Otherwise>
                </Choose>
              </div>
            </Loader>
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

export default (compose(
  connect(
    state => ({
      browser: state.browser,
      reviews: state.reviews,
    }),
    reviewsActions,
  ),
  pure,
)(ReviewRetortComponent): any);



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/ReviewRetort.js